import React from "react";
import { Outlet } from "react-router";
import { useOrgContext } from "@/contexts/OrgContext";

export function OrgAdminLayout() {
  let orgRole: string | null | undefined;
  try {
    ({ orgRole } = useOrgContext());
  } catch {
    // Context not ready yet (e.g. loading)
    return (
      <div className="p-8 text-center text-muted-foreground">
        Loading organisation…
      </div>
    );
  }

  // Only ADMINs can view
  if (orgRole !== "ADMIN") {
    return (
      <div className="p-8 text-center text-destructive">
        You must be an organisation admin to view this page.
      </div>
    );
  }

  return <Outlet />;
}
